import { render, staticRenderFns } from "./OfficialAcInfo.vue?vue&type=template&id=4efd96d6&scoped=true&"
import script from "./OfficialAcInfo.vue?vue&type=script&lang=js&"
export * from "./OfficialAcInfo.vue?vue&type=script&lang=js&"
import style0 from "./OfficialAcInfo.vue?vue&type=style&index=0&id=4efd96d6&lang=less&scoped=true&"
import style1 from "./OfficialAcInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd96d6",
  null
  
)

export default component.exports